    let $formFieldContainer = jQuery('.js-page-form').find('.form-field');
    let $formField = $formFieldContainer.find('.formField-js');

    $formField.on('focusout', function() {
        let $currentField = jQuery(this);
        jQuery(this).parents('.form-field').removeClass('focus');
        if ($currentField.val().length > 0) {
            jQuery(this).parents('.form-field').addClass('not-empty');
        } else {
            jQuery(this).parents('.form-field').removeClass('not-empty');
        }
    });
    $formField.on('focus', function() {
        jQuery(this).parents('.form-field').addClass('focus');
    });
    $formField.on('change', function() {
        let $currentField = jQuery(this);
        if ($currentField.val().length > 0) {
        jQuery(this).parents('.form-field').addClass('not-empty');
        }
    });
    $formField.each(function() {
        let $currentField = jQuery(this);
        if ($currentField.val().length > 0) {
        jQuery(this).parents('.form-field').addClass('not-empty');
        }
    });
    let iwainterval = setInterval(function() {
        if (jQuery('input:-webkit-autofill')) {
            jQuery('input:-webkit-autofill').each(function() {
                jQuery(this).parents('.form-field').addClass('not-empty');
            });
        }
    }, 200);
    import( /* webpackChunkName: "select2-time" */ 'select2').then(()=>{
        $("select.form-control.select2-search").select2({ minimumResultsForSearch: 1 });
        $("select.form-control").not(".select2-search").select2( { minimumResultsForSearch: -1 } );
    })
    jQuery('select.form-control').on('select2:open', function (e) {
        jQuery(this).parents('.form-field').addClass('focus');
    });
    jQuery(window).on('load', function() {
        clearInterval(iwainterval);
    });
